import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronLeft, ChevronRight, Download } from 'lucide-react';

const DoctorAccountsMainPage = () => {
  const navigate = useNavigate();
  
  // Set page title
  useEffect(() => {
    document.title = 'MediFusion - Doctor Accounts';
  }, []);

  // State for accounts data - matching the uploaded image structure
  const [accountsData, setAccountsData] = useState([
    {
      date: '15/08/2024',
      rctiReference: 'RCTI-MDC-2024-08-001',
      viewDownload: '',
      dateRight: '16/08/2024',
      description: 'Telehealth Consultation Services',
      viewDownloadRight: ''
    },
    {
      date: '22/08/2024',
      rctiReference: 'RCTI-MDC-2024-08-002',
      viewDownload: '',
      dateRight: '23/08/2024',
      description: 'Specialist Medical Examination',
      viewDownloadRight: ''
    },
    {
      date: '29/08/2024',
      rctiReference: 'RCTI-MDC-2024-08-003',
      viewDownload: '',
      dateRight: '30/08/2024',
      description: 'Follow-up Consultation Services',
      viewDownloadRight: ''
    },
    {
      date: '05/09/2024',
      rctiReference: 'RCTI-MDC-2024-09-001',
      viewDownload: '',
      dateRight: '06/09/2024',
      description: 'Comprehensive Health Assessment',
      viewDownloadRight: ''
    },
    {
      date: '12/09/2024',
      rctiReference: 'RCTI-MDC-2024-09-002',
      viewDownload: '',
      dateRight: '13/09/2024',
      description: 'Mental Health Consultation',
      viewDownloadRight: ''
    },
    {
      date: '19/09/2024',
      rctiReference: 'RCTI-MDC-2024-09-003',
      viewDownload: '',
      dateRight: '20/09/2024',
      description: 'Pediatric Consultation Services',
      viewDownloadRight: ''
    },
    {
      date: '26/09/2024',
      rctiReference: 'RCTI-MDC-2024-09-004',
      viewDownload: '',
      dateRight: '27/09/2024',
      description: 'Dermatology Consultation',
      viewDownloadRight: ''
    },
    {
      date: '03/10/2024',
      rctiReference: 'RCTI-MDC-2024-10-001',
      viewDownload: '',
      dateRight: '04/10/2024',
      description: 'Orthopedic Assessment Services',
      viewDownloadRight: ''
    }
  ]);

  const [loading, setLoading] = useState(false);

  const handleDownload = (index, side) => {
    console.log(`Download clicked for row ${index}, side ${side}`);
    // Handle download functionality
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 p-6">
        <div className="flex items-center justify-center h-64">
          <div className="flex items-center space-x-2">
            <svg className="animate-spin h-6 w-6 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span className="text-blue-600 font-medium">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Main Content */}
      <div className="p-6">
        {/* Accounts Header - Full Width */}
        <div className="bg-blue-600 text-white px-6 py-1.5 rounded-lg mb-6">
          <h1 className="text-lg font-semibold text-center">Accounts</h1>
        </div>

        <div className="flex gap-6">
          {/* Left Column - Navigation */}
          <div className="w-[20%]">
            <div className="bg-white rounded-lg shadow-md">
              {/* Navigation Options */}
              <div className="p-4 space-y-3">
                <Link 
                  to="/doctor/accounts/rcti"
                  className="w-full bg-gray-100 text-gray-700 px-4 py-3 rounded-lg text-sm font-medium hover:bg-gray-200 hover:scale-105 transform transition-all duration-200 flex items-center justify-center shadow-sm hover:shadow-lg"
                >
                  <span>RCTI</span>
                </Link>
                
                <Link 
                  to="/doctor/accounts"
                  className="w-full bg-blue-600 text-white px-4 py-3 rounded-lg text-sm font-medium hover:bg-blue-700 hover:scale-105 transform transition-all duration-200 flex items-center justify-center shadow-md hover:shadow-xl"
                >
                  <span>Accounts</span>
                </Link>
              </div>
            </div>
          </div>

                      {/* Right Column - Accounts Content */}
            <div className="w-[80%]">
              <div className="bg-white rounded-lg shadow-md">
                {/* Accounts Header */}
                <div className="bg-white px-4 py-2 rounded-t-lg border-b-2 border-blue-500">
                  <h3 className="font-bold text-xl text-blue-600 text-center">Accounts</h3>
                </div>
                
                {/* Accounts Table */}
                <div className="p-4">
                <div className="overflow-x-auto">
                <table className="w-full border-collapse text-xs">
                  <thead>
                    <tr className="bg-blue-100">
                      <th className="border-r border-gray-300 px-2 py-1 text-center text-xs font-medium text-gray-700 w-20">Date</th>
                      <th className="border border-gray-300 px-2 py-1 text-center text-xs font-medium text-gray-700 w-40">RCTI Reference</th>
                      <th className="border border-gray-300 px-1 py-1 text-center text-xs font-medium text-gray-700 w-12" style={{borderRight: 'none'}}>Action</th>
                      <th className="bg-white" style={{width: '30px'}}></th>
                      <th className="border border-gray-300 px-2 py-1 text-center text-xs font-medium text-gray-700 w-20" style={{borderLeft: 'none'}}>Date</th>
                      <th className="border border-gray-300 px-2 py-1 text-center text-xs font-medium text-gray-700 w-40">Description</th>
                      <th className="border-l border-gray-300 px-1 py-1 text-center text-xs font-medium text-gray-700 w-12">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {accountsData.map((row, index) => (
                      <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                        <td className="border-r border-gray-300 px-2 py-2 text-xs text-gray-700 text-center">{row.date}</td>
                        <td className="border border-gray-300 px-2 py-2 text-xs text-gray-700 text-center">{row.rctiReference}</td>
                        <td className="border border-gray-300 px-1 py-2 text-center" style={{borderRight: 'none'}}>
                          <button
                            onClick={() => handleDownload(index, 'left')}
                            className="bg-green-100 text-green-600 px-1 py-1 rounded text-xs hover:bg-green-200 hover:scale-110 transform transition-all duration-150 shadow-sm hover:shadow-md flex items-center justify-center mx-auto"
                          >
                            <Download className="h-3 w-3" />
                          </button>
                        </td>
                        <td className="bg-white" style={{width: '30px'}}></td>
                        <td className="border border-gray-300 px-2 py-2 text-xs text-gray-700 text-center" style={{borderLeft: 'none'}}>{row.dateRight}</td>
                        <td className="border border-gray-300 px-2 py-2 text-xs text-gray-700 text-center">{row.description}</td>
                        <td className="border-l border-gray-300 px-1 py-2 text-center">
                          <button
                            onClick={() => handleDownload(index, 'right')}
                            className="bg-green-100 text-green-600 px-1 py-1 rounded text-xs hover:bg-green-200 hover:scale-110 transform transition-all duration-150 shadow-sm hover:shadow-md flex items-center justify-center mx-auto"
                          >
                            <Download className="h-3 w-3" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorAccountsMainPage;
